const $clearFiltersButton = $('[data-clear-filters]');
const $openMobileFilters = $('[data-open-mobile-filters]');
const $closeMobileFilters = $('[data-close-mobile-filters]');
const $mobileFilterPanel = $('[data-mobile-filter-panel]');

const mixer = mixitup('.main-content-container', {
  multifilter: {
    enable: true
  },
  animation: {
    enable: false
  },
  callbacks: {
    onMixEnd: function(state) {
      if (state.activeFilter.selector === '.mix') {
        $clearFiltersButton.fadeOut();
      } else {
        $clearFiltersButton.fadeIn();
      }
    }
  }
});

/* $clearFiltersButton.on('click',() => {
  mixer.filter('.mix');
  $('[data-filter-group]').find('input:checked').prop('checked',false).change();
});*/

$clearFiltersButton.on('click', () => {
  const $inputs = $('[data-filter-group]').find('input[type="checkbox"]');
  $inputs.prop('checked', false).trigger('change');
  mixer.filter('all');
});

$openMobileFilters.on('click',() => {
  $mobileFilterPanel.addClass('active');
});

$closeMobileFilters.on('click',() => {
  $mobileFilterPanel.removeClass('active');
});